<template>
  <Head :head-height="44" :title="title" />
  <div class="content">
    <router-view />
  </div>
  <div id="tabs">
    <div
      class="tab"
      v-for="(item, index) in tabs"
      :key="index"
      @click="handleTabClick(item, index)"
    >
      <img
        class="img"
        :src="tabSelect === index ? item.iconSelect : item.icon"
      />
      <span :class="tabSelect === index ? 'select' : 'no-select'">{{
        item.label
      }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import Head from "@/components/head/Head.vue";
import { onMounted, ref } from "vue";

import shouye from "@/assets/images/shouye.png";
import shouyeCopy from "@/assets/images/shouye-copy.png";
import liebiao from "@/assets/images/liebiao.png";
import liebiaoCopy from "@/assets/images/liebiao-copy.png";
import wode from "@/assets/images/wode.png";
import wodeCopy from "@/assets/images/wode-copy.png";
import router from "@/router";
import { getCache, setCache } from "@/utils/cache";
import { Info, LastHref } from "@/constants/cacheKey";
import { getUserInfo } from "@/api/User";
import { ElMessage } from "element-plus";

const tabSelect = ref<number>(0);

const tabs = ref([
  {
    label: "首页",
    href: "/project/index",
    titleShow: true,
    icon: shouye,
    iconSelect: shouyeCopy,
  },
  {
    label: "提交事件列表",
    href: "/event-list/index",
    titleShow: true,
    icon: liebiao,
    iconSelect: liebiaoCopy,
  },
  {
    label: "我的",
    href: "/my/index",
    titleShow: false,
    icon: wode,
    iconSelect: wodeCopy,
  },
]);

const title = ref("");

// tab点击
function handleTabClick(item: any, index: number) {
  tabSelect.value = index;
  router.push(item.href);
  setCache(LastHref, { item: item, index: index });
  title.value = item.titleShow ? item.label : "";
  // document.title = item.label
}

function onInfo() {
  getUserInfo()
    .then((res) => {
      if (res.code === 200) {
        setCache(Info, res.data);
        return;
      }
      ElMessage.error({
        message: res.msg,
        offset: 64,
      });
    })
    .catch((err) => {
      ElMessage.error({
        message: err.message,
        offset: 64,
      });
    });
}

onMounted(() => {
  onInfo();

  const obj = getCache(LastHref);
  if (obj) {
    handleTabClick(obj.item, obj.index);
    return;
  }
  handleTabClick(tabs.value[0], 0);
});
</script>

<style lang="less">
html {
  height: 100vh;
  overflow: hidden;
}
.content {
  background-color: #f8f8f8;
  height: calc(100vh - 104px);
}
#tabs {
  border-top: 1px solid rgba(0, 0, 0, 0.33);
  box-sizing: border-box;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 60px;
  display: flex;
  .tab {
    background: white;
    flex: 1;
    // border: 1px solid #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // box-sizing: border-box;

    .img {
      width: 24px;
      height: 24px;
    }

    span {
      font-size: 18px;
      margin-top: 5px;
    }

    .select {
      color: rgb(18, 150, 219);
    }

    .no-select {
      color: rgb(122, 126, 131);
    }
  }
}
</style>
